import { Component, Input, OnChanges } from '@angular/core';
import { RateIndex } from '../../models/models';
import { CRMService } from '../../services/crm.service';

@Component({
    selector: 'rate-index-indicator',
    templateUrl: './rate-index-indicator.component.html',
    standalone: false
})
export class RateIndexIndicator implements OnChanges {
    @Input() rateIndexID: number = 0;
    @Input() rateIndexName: string = "";
    public rateIndexList: RateIndex[] = [];
    public indicatorClass: string = "light";
    public indicatorAbbrev: string = "";
    public indicatorDescription: string = "";

    constructor(private crmService: CRMService) {
        if (this.rateIndexName == "" && this.rateIndexID > 0) {
            this.crmService.getRateIndices().subscribe(result => {
                this.rateIndexList = result;
            });
        }
    }

    ngOnChanges() {
        if (this.rateIndexName != "") {
            this.indicatorDescription = this.rateIndexName;
            this.getRateIndexByName();
        }
        else if (this.rateIndexList.length > 0) {
            this.getRateIndexByID();
        }
    }

    private getRateIndexByID() {
        var rateIndex = this.rateIndexList.find(t => t.rateIndexID == this.rateIndexID);
        if (rateIndex != null) {
            this.indicatorDescription = rateIndex.description;
        }
        this.getRateIndexByName();
    }

    private getRateIndexByName() {
        this.indicatorAbbrev = this.indicatorDescription.substr(0, 1);
        if (this.indicatorAbbrev == "E") {
            this.indicatorClass = "danger";
        }
        else if (this.indicatorAbbrev == "S") {
            this.indicatorClass = "warning";
        }
        else if (this.indicatorAbbrev == "C") {
            this.indicatorClass = "success";
        }
        //console.log("getRateIndexByName", this.rateIndexID, this.rateIndexName, this.indicatorAbbrev, this.indicatorClass, this.indicatorDescription);
    }
}
